﻿import { useTranslation } from "react-i18next";
import TopBar from "@/pages/home/components/TopBar";
import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import StickyMobile from "@/pages/home/components/StickyMobile";
import Breadcrumb from "./components/Breadcrumb";
import HeroContact from "./components/HeroContact";
import ContactCards from "./components/ContactCards";
import Openingstijden from "./components/Openingstijden";
import ContactForm from "./components/ContactForm";
import GoogleMapEmbed from "./components/GoogleMapEmbed";
import WijkenBereikbaarheid from "./components/WijkenBereikbaarheid";
import FAQContact from "./components/FAQContact";
import CTABannerContact from "./components/CTABannerContact";

function SchemaMarkup() {
  const contactPageSchema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: "Contact",
    url: "https://ramen-repair-eindhoven.nl/contact/",
    mainEntity: {
      "@type": "LocalBusiness",
      name: "Ramen Repair Eindhoven",
      url: "https://ramen-repair-eindhoven.nl/",
      telephone: "+31407987470",
      email: "info@ramen-repair-eindhoven.nl",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Eindhoven",
        addressRegion: "Noord-Brabant",
        addressCountry: "NL",
      },
      areaServed: {
        "@type": "City",
        name: "Eindhoven",
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          opens: "08:00",
          closes: "20:00",
        },
      ],
      priceRange: "€€",
      geo: {
        "@type": "GeoCoordinates",
        latitude: "51.44",
        longitude: "5.46",
      },
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://ramen-repair-eindhoven.nl/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Contact",
        item: "https://ramen-repair-eindhoven.nl/contact/",
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(contactPageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
    </>
  );
}

export default function Contact() {
  const { t } = useTranslation("contact");

  return (
    <main className="bg-white min-h-screen">
      <title>{t("seo.title", { defaultValue: "Contact | Ramen Repair Eindhoven — Bel 040 798 7470" })}</title>
      <meta name="description" content={t("seo.description", { defaultValue: "Neem contact op met Ramen Repair Eindhoven voor kozijn-, raam- en schuifpuireparatie. Telefoon 040 798 7470, 7 dagen per week bereikbaar." })} />
      <meta property="og:title" content={t("seo.title", { defaultValue: "Contact | Ramen Repair Eindhoven — Bel 040 798 7470" })} />
      <meta property="og:description" content={t("seo.description", { defaultValue: "Neem contact op met Ramen Repair Eindhoven voor kozijn-, raam- en schuifpuireparatie. Telefoon 040 798 7470, 7 dagen per week bereikbaar." })} />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://ramen-repair-eindhoven.nl/contact/" />
      <meta property="og:image" content="/og/og-contact.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Ramen Repair Eindhoven - kozijn en raamreparatie" />
      <link rel="canonical" href="https://ramen-repair-eindhoven.nl/contact/" />
      <link rel="alternate" hreflang="nl-NL" href="https://ramen-repair-eindhoven.nl/contact/" />
      <link rel="alternate" hreflang="x-default" href="https://ramen-repair-eindhoven.nl/contact/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t("seo.title", { defaultValue: "Contact | Ramen Repair Eindhoven — Bel 040 798 7470" })} />
      <meta name="twitter:description" content={t("seo.description", { defaultValue: "Neem contact op met Ramen Repair Eindhoven voor kozijn-, raam- en schuifpuireparatie. Telefoon 040 798 7470, 7 dagen per week bereikbaar." })} />
      <meta name="twitter:image" content="/og/og-contact.jpg" />
      <meta name="geo.position" content="51.44;5.46" />
      <meta name="geo.region" content="NL-NB" />
      <meta name="geo.placename" content="Eindhoven" />
      <SchemaMarkup />
      <TopBar />
      <Header />
      <Breadcrumb />
      <HeroContact />
      <ContactCards />
      <Openingstijden />
      <ContactForm />
      <GoogleMapEmbed />
      <WijkenBereikbaarheid />
      <FAQContact />
      <CTABannerContact />
      <Footer />
      <StickyMobile />
    </main>
  );
}